export const FLOATING_COMMENT_WIDTH = 320;
